var ko = require('knockout');

function CourseRegistrationFeedbackBox(params) {
  var self = this;

  self.errorMessage = params.errorMessage;
  self.hasError = ko.computed(function() {
    return !!self.errorMessage() && self.errorMessage().length > 0;
  });
}

CourseRegistrationFeedbackBox.prototype.closeError = function() {
  this.errorMessage('');
};

module.exports = CourseRegistrationFeedbackBox;
